import { render, staticRenderFns } from "./CardDiscipline.vue?vue&type=template&id=462358d5"
import script from "./CardDiscipline.vue?vue&type=script&lang=js"
export * from "./CardDiscipline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports